import { ChannelListProviderInterface } from 'SendbirdUIKitGlobal';

export const getCurrentChannel = (channelListState: ChannelListProviderInterface, currentChannelId: string | null) =>
  channelListState?.allChannels.find(({ url }) => url === currentChannelId);
